// LICENSE : MIT
"use strict";
export function isJapanese(text) {
    return /([\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]|[\uD840-\uD87F][\uDC00-\uDFFF]|[ぁ-んァ-ヶ])/.test(text)
}